// ----------------------------------------------------------------------

const account = {
  displayName: 'HH Informatique Manager',
  email: 'quentin@tuaux.net',
  photoURL: '',
};

export default account;
